import { selectAgentV2ReferencesByCitationId } from '@/agent-v2/references/store/selectors'
import type { RootState } from '@/store/store'
import { useAppSelector } from '@/store/store-hooks'
import { DocketRecordViewer } from './DocketRecordViewer'

export function AgentV2DocketRecordViewer({ conversationId, citationId }: { conversationId: string; citationId: string }) {
  const reference = useAppSelector((state: RootState) => selectAgentV2ReferencesByCitationId(state, { conversationId })[citationId])
  return <DocketRecordViewer record={reference?.source_type === 'docket' ? reference : undefined} />
}
